// extracted by mini-css-extract-plugin
module.exports = {"loadingStyle":"index_loadingStyle__5mP4g","loading":"index_loading__Asxmj"};